import React, {useCallback, useState} from 'react';
import withStore from "@/hocs/withStore";
import {isDesktop, isMobile} from "@/Helpers/Function";
import CardAll from "@/Pages/All/CardAll";
import CardModel from "@/Pages/All/CardModel";
import Svg from "@/Pages/All/Svg";
import {Swiper, SwiperSlide} from "swiper/react";
import {Pagination} from "swiper/modules";

const OtherModelsComponent = (props) => {
    const {product = {}} = props;
    const {productsModel = []} = product;
    const [swiper, setSwiper] = useState(null);

    const swiperSettings = {
        loop: true,
        slidesPerView: 2,
        spaceBetween: 10,
        className: 'otherModelsSwiper',
        pagination: {
            clickable: true,
            dynamicBullets: true,
        },
        modules: [Pagination],
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 2,
                spaceBetween: 4,
                pagination: {
                    clickable: true,
                    dynamicBullets: true,
                },
            },
            // when window width is >= 577px
            577: {
                slidesPerView: 3,
                spaceBetween: 8,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 1,
            },
            // when window width is >= 992px
            992: {
                slidesPerView: 1,
                spaceBetween: 10,
                pagination: false,
            },
            // when window width is >= 1200px
            1200: {
                slidesPerView: 1,
                pagination: false,
            },
            // when window width is >= 1366px
            1366: {
                slidesPerView: 2,
                pagination: false,
            },
        }
    };

    const ArrowPrev = () => {
        let className = 'swiperNavigationContainer__arrow swiperNavigationContainer__arrow_left';

        const handlePrev = useCallback(() => {
            if (!swiper) return;
            swiper.slidePrev();
        }, []);

        return <div className={className} onClick={handlePrev}>
            <Svg id={`arrows-left`} className={`svg__swiperArrow`} />
        </div>
    }

    const ArrowNext = () => {
        let className = 'swiperNavigationContainer__arrow swiperNavigationContainer__arrow_right';

        const handleNext = useCallback(() => {
            if (!swiper) return;
            swiper.slideNext();
        }, []);

        return <div className={className} onClick={handleNext}>
            <Svg id={`arrows-right`} className={`svg__swiperArrow`} />
        </div>
    }

    let sliderElements;
    if (isMobile()) {
        sliderElements = productsModel.map((el) => {
            return <SwiperSlide key={el.id}><CardAll el={el} {...props} /></SwiperSlide>
        });
    } else {
        sliderElements = productsModel.map((el) => {
            return <SwiperSlide key={el.id}><CardModel el={el} {...props} /></SwiperSlide>
        });
    }

    const className = productsModel.length > 1 ? 'otherModelsSliderContainer' : 'otherModelsNotSliderContainer';

    if (productsModel.length === 0) return null;

    return <div className={`product product__otherModels`}>
        <p className={`product__title`}>Другие варианты модели</p>
        <div className={`${className}${swiper?.isLocked ? '' : ' notLocked'}`}>
            <Swiper onSwiper={setSwiper} {...swiperSettings}>
                {sliderElements}
            </Swiper>
            {isDesktop() && swiper !== null && !swiper.isLocked && (
                <>
                    <ArrowPrev />
                    <ArrowNext />
                </>
            )}
        </div>
    </div>
};

export default withStore(OtherModelsComponent);
